import { AccountInformationEffect } from './account-information.effect';
import { AccountInvoicesEffect } from './account-invoices.effects';
import { UserInformationEffect } from './user-information.effects';

export const effects: Array<any> = [
  AccountInformationEffect,
  UserInformationEffect,
  AccountInvoicesEffect
];

export * from './account-information.effect';
export * from './account-invoices.effects';
export * from './user-information.effects';
